import React, { useState, useEffect } from 'react';
import { useForm, Controller } from 'react-hook-form';
import { ErrorMessage } from '@hookform/error-message';
import { toast } from 'react-toastify';
import ServiceChannelService from '../service';
import SimpleHeader from 'components/Headers/SimpleHeader.js';
import DefaultModal from 'components/Modal/DefaultModal';
import { useHistory } from 'react-router-dom';

import {
  Container,
  Row,
  Card,
  Form,
  Col,
  Input,
  CardHeader,
  CardBody
} from 'reactstrap';
import ReactLoader from 'components/Loader';
import ReactButton from 'components/Buttons/ReactButton';
import { ScreenPrompt } from 'components/ScreenPrompt';
import ModalConfirmation from '../../../components/Modal/ConfirmationModal';

const ServiceChannelForm = (props) => {
  const history = useHistory();
  const { reset, control, handleSubmit, errors, formState, getValues } =
    useForm();
  const { isDirty } = formState;
  const [isUpdate, setIsUpdate] = useState(false);
  const [loading, setLoading] = useState(false);
  const [openModalConfirmation, setOpenModalConfirmation] = useState(false);
  const { id } = props.match.params;
  const isModal =
    typeof props.isModalOpen === 'boolean' || props.location?.state?.modal;

  const closeModal = () => {
    if (typeof reset === 'function') reset({ name: '' });
    setIsUpdate(false);
    setOpenModalConfirmation(false);

    if (isModal && typeof props.onModalToggle === 'function') {
      props.onModalToggle(false);
      return;
    }

    history.push('/admin/serviceChannel');
  };

  useEffect(() => {
    if (typeof props.isModalOpen === 'boolean' && props.isModalOpen === false) {
      if (typeof reset === 'function') reset({ name: '' });
      setIsUpdate(false);
      setOpenModalConfirmation(false);
    }
  }, [props.isModalOpen, reset]);

  useEffect(() => {
    if (id) {
      setLoading(true);
      ServiceChannelService.get(id)
        .then((res) => {
          console.log(res);
          const getServiceChannel = res.data;
          reset({ ...getServiceChannel });
          setIsUpdate(true);
          setLoading(false);
        })
        .catch((err) => {
          const { data } = err.response;
          toast.error(data.message || 'Erro ao listar canal de atendimento!', {
            autoClose: 3000,
            closeOnClick: true
          });
          setLoading(false);
        });
    }
  }, [id, reset]);

  const onSubmit = async (data, isSubmittingFromModal) => {
    if (isUpdate && !isSubmittingFromModal) {
      setOpenModalConfirmation(true);
      return;
    }
    try {
      isUpdate
        ? await ServiceChannelService.update(id, data)
        : await ServiceChannelService.create(data);

      toast.success(
        `Motivo ${isUpdate ? 'atualizado' : 'criado'} com sucesso`,
        {
          autoClose: 3000,
          closeOnClick: true
        }
      );
      reset({ name: '' });
      if (isModal && typeof props.onModalToggle === 'function') {
        props.onModalToggle(false);
        if (typeof props.onSaved === 'function') props.onSaved();
        return;
      }

      history.push('/admin/serviceChannel');
    } catch (err) {
      const { data } = err.response;
      toast.error(data.message || 'Erro ao cadastrar motivo!', {
        autoClose: 3000,
        closeOnClick: true
      });
    }
  };

  const errorFormMessage = (message) => (
    <p style={{ color: 'red' }}>{message}</p>
  );

  const cancelAction = () => closeModal();

  const formContent = (
    <>
      <ScreenPrompt
        when={isDirty && !(formState.isSubmitting || formState.isSubmitted)}
        message={`Está certo de que deseja sair? Terá que preencher os dados novamente quando retornar`}
      />
      {loading ? (
        <Row className="justify-content-md-center">
          <ReactLoader />
        </Row>
      ) : (
        <Form
          className="needs-validation"
          onSubmit={handleSubmit(() => {
            onSubmit(getValues(), false);
          })}
        >
          <Row className="mb-3">
            <Col md="6">
              <label className="form-control-label">Nome*</label>
              <Controller
                as={Input}
                control={control}
                name="name"
                rules={{ required: 'Nome é obrigatório!' }}
                defaultValue=""
              />
              <ErrorMessage
                errors={errors}
                name="name"
                render={({ message }) => errorFormMessage(message)}
              />
            </Col>
          </Row>
          <hr />

          <ReactButton btnColor="confirmation" type="submit">
            Salvar
          </ReactButton>

          <ReactButton btnColor="cancelation" onClick={() => cancelAction()}>
            Cancelar
          </ReactButton>
        </Form>
      )}

      {isUpdate && (
        <ModalConfirmation
          modalConfirmationSize="md"
          isModalOpen={openModalConfirmation}
          onModalToggle={setOpenModalConfirmation}
          unmountOnClose={true}
          message={'Deseja confirmar a atualização deste canal de atendimento?'}
          deleteResource={() => {
            setOpenModalConfirmation(false);
            const data = getValues();
            onSubmit(data, true);
          }}
        />
      )}
    </>
  );

  if (isModal) {
    return (
      <DefaultModal
        show={props.isModalOpen}
        onModalToggle={props.onModalToggle}
        title={
          isUpdate
            ? 'Editar canal de atendimento'
            : 'Criar canal de atendimento'
        }
        showCloseButton={false}
        modalContainerClasses="modal-md"
      >
        {formContent}
      </DefaultModal>
    );
  }

  return (
    <>
      <SimpleHeader
        name="Form validation"
        parentName="Forms"
        returnPath="/admin/serviceChannel"
        buttonTitle="Voltar para a pagina de Canais de Atendimento"
      />
      <Container className="mt--6" fluid>
        <Row className="mb-3">
          <div className="col">
            <div className="card-wrapper">
              <Card>
                <CardHeader>
                  <h3 className="mb-0">Canal de atendimento</h3>
                </CardHeader>
                <CardBody>{formContent}</CardBody>
              </Card>
            </div>
          </div>
        </Row>
      </Container>
    </>
  );
};

export default ServiceChannelForm;
